var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "format-select",
    "class": _vm.inputClass
  }, [_vm.fixedLabel ? _c('label', {
    staticClass: "settings-field-label",
    attrs: {
      "for": "format-select-".concat(_vm._uid)
    }
  }, [_vm._v(_vm._s(_vm.label))]) : _vm._e(), _c('v-menu', {
    attrs: {
      "close-on-content-click": false,
      "offset-y": "",
      "max-width": "360",
      "min-width": "300",
      "disabled": _vm.disabled || _vm.loading,
      "content-class": "format-select__menu"
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function fn(_ref) {
        var on = _ref.on,
          attrs = _ref.attrs;
        return [_c('v-text-field', _vm._g(_vm._b({
          ref: "field",
          attrs: {
            "value": _vm.closedDisplayText,
            "readonly": "",
            "id": _vm.fixedLabel ? "format-select-".concat(_vm._uid) : undefined,
            "label": _vm.fixedLabel ? null : _vm.label,
            "placeholder": _vm.placeholder || (_vm.fixedLabel ? _vm.label : undefined),
            "loading": _vm.loading,
            "disabled": _vm.disabled,
            "clearable": false,
            "dense": _vm.dense,
            "outlined": _vm.outlined,
            "filled": _vm.filled,
            "hide-details": _vm.hideDetails,
            "error-messages": _vm.errorMessages,
            "hint": _vm.hint,
            "persistent-hint": _vm.persistentHint,
            "autofocus": _vm.autofocus,
            "append-icon": _vm.appendIcon
          },
          on: {
            "click:append": _vm.onAppendClick,
            "keydown": _vm.onFieldKeydown,
            "blur": function blur($event) {
              return _vm.$emit('blur');
            }
          }
        }, 'v-text-field', attrs, false), on))];
      }
    }]),
    model: {
      value: _vm.menuOpen,
      callback: function callback($$v) {
        _vm.menuOpen = $$v;
      },
      expression: "menuOpen"
    }
  }, [_c('v-card', {
    staticClass: "format-select__panel"
  }, [_vm.kindFirst && _vm.step === 'kind' ? _c('div', {
    staticClass: "format-select__step"
  }, [_c('v-list', {
    staticClass: "py-0 format-select__list",
    attrs: {
      "dense": ""
    }
  }, _vm._l(_vm.kindOptions, function (kind) {
    return _c('v-list-item', {
      key: kind.id,
      "class": {
        'v-list-item--active': kind.selected
      },
      on: {
        "click": function click($event) {
          return _vm.onKindSelect(kind);
        }
      }
    }, [_c('v-list-item-title', [_vm._v(" " + _vm._s(kind.text) + " ")]), _c('v-list-item-action', {
      staticClass: "my-0"
    }, [kind.selected ? _c('v-icon', {
      attrs: {
        "small": "",
        "color": "primary"
      }
    }, [_vm._v(" mdi-check ")]) : !kind.immediate ? _c('v-icon', {
      attrs: {
        "small": ""
      }
    }, [_vm._v(" mdi-chevron-right ")]) : _vm._e()], 1)], 1);
  }), 1)], 1) : _vm.kindFirst && _vm.step === 'units' ? _c('div', {
    staticClass: "format-select__step"
  }, [_c('div', {
    staticClass: "d-flex align-center px-2 pt-1"
  }, [_vm.showKindBack ? _c('v-btn', {
    staticClass: "mr-1",
    attrs: {
      "icon": "",
      "x-small": ""
    },
    on: {
      "click": _vm.backToKinds
    }
  }, [_c('v-icon', {
    attrs: {
      "small": ""
    }
  }, [_vm._v("mdi-arrow-left")])], 1) : _vm._e(), _c('div', {
    staticClass: "text-body-2 font-weight-medium"
  }, [_vm._v(" " + _vm._s(_vm.detailKindLabel) + " ")])], 1), _c('v-list', {
    staticClass: "py-0 format-select__list",
    attrs: {
      "dense": ""
    }
  }, _vm._l(_vm.detailKindUnits, function (unit) {
    return _c('v-list-item', {
      key: String(unit.value),
      "class": {
        'v-list-item--active': unit.value === _vm.selectedKindUnit
      },
      on: {
        "click": function click($event) {
          return _vm.onKindUnitSelect(unit.value);
        }
      }
    }, [_c('v-list-item-title', [_vm._v(_vm._s(unit.text))]), unit.value === _vm.selectedKindUnit ? _c('v-list-item-action', {
      staticClass: "my-0"
    }, [_c('v-icon', {
      attrs: {
        "small": "",
        "color": "primary"
      }
    }, [_vm._v("mdi-check")])], 1) : _vm._e()], 1);
  }), 1)], 1) : [!_vm.kindFirst && _vm.actionItems.length && !_vm.isFormatSearchActive ? _c('div', {
    staticClass: "format-select__actions"
  }, [_c('v-list', {
    staticClass: "py-0",
    attrs: {
      "dense": ""
    }
  }, _vm._l(_vm.actionItems, function (action) {
    return _c('v-list-item', {
      key: 'action-' + String(action.value),
      on: {
        "click": function click($event) {
          return _vm.onActionSelect(action.value);
        }
      }
    }, [_c('v-list-item-title', [_vm._v(" " + _vm._s(action.text) + " ")])], 1);
  }), 1), _c('v-divider')], 1) : _vm._e(), _vm.step === 'container' ? _c('div', {
    staticClass: "format-select__step"
  }, [_vm.kindFirst ? _c('div', {
    staticClass: "d-flex align-center px-2 pt-1"
  }, [_vm.showKindBack ? _c('v-btn', {
    staticClass: "mr-1",
    attrs: {
      "icon": "",
      "x-small": ""
    },
    on: {
      "click": _vm.backToKinds
    }
  }, [_c('v-icon', {
    attrs: {
      "small": ""
    }
  }, [_vm._v("mdi-arrow-left")])], 1) : _vm._e(), _c('div', {
    staticClass: "text-body-2 font-weight-medium"
  }, [_vm._v(" " + _vm._s(_vm.$translate("kindFormat")) + " ")])], 1) : _vm._e(), !_vm.isFormatSearchActive ? _c('div', {
    staticClass: "format-select__step-title px-3 pt-2 pb-1 text-caption grey--text text--darken-1"
  }, [_vm._v(" " + _vm._s(_vm.$translate("pickContainer")) + " ")]) : _vm._e(), _vm.showFormatSearchField ? _c('v-text-field', {
    ref: "formatSearch",
    staticClass: "px-3 pb-1",
    attrs: {
      "dense": "",
      "hide-details": "",
      "clearable": "",
      "placeholder": _vm.$translate('searchFormat'),
      "prepend-inner-icon": "mdi-magnify"
    },
    model: {
      value: _vm.containerSearch,
      callback: function callback($$v) {
        _vm.containerSearch = $$v;
      },
      expression: "containerSearch"
    }
  }) : _vm._e(), _vm.isFormatSearchActive && _vm.searchedFormatOptions.length ? _c('v-list', {
    staticClass: "py-0 format-select__list",
    attrs: {
      "dense": ""
    }
  }, _vm._l(_vm.searchedFormatOptions, function (option) {
    return _c('v-list-item', {
      key: 'format-' + option.key,
      "class": {
        'v-list-item--active': option.selected
      },
      on: {
        "click": function click($event) {
          return _vm.onSearchedFormatSelect(option.format);
        }
      }
    }, [_c('v-list-item-title', [_vm._v(_vm._s(option.label))]), option.selected ? _c('v-list-item-action', {
      staticClass: "my-0"
    }, [_c('v-icon', {
      attrs: {
        "small": "",
        "color": "primary"
      }
    }, [_vm._v("mdi-check")])], 1) : _vm._e()], 1);
  }), 1) : !_vm.isFormatSearchActive && _vm.containerOptions.length ? _c('v-list', {
    staticClass: "py-0 format-select__list",
    attrs: {
      "dense": ""
    }
  }, _vm._l(_vm.containerOptions, function (option) {
    return _c('v-list-item', {
      key: option.key,
      on: {
        "click": function click($event) {
          return _vm.onContainerSelect(option);
        }
      }
    }, [_c('v-list-item-title', [_vm._v(_vm._s(option.label))]), _c('v-list-item-action', {
      staticClass: "my-0"
    }, [_c('v-icon', {
      attrs: {
        "small": ""
      }
    }, [_vm._v("mdi-chevron-right")])], 1)], 1);
  }), 1) : _c('div', {
    staticClass: "px-3 py-3 text-caption grey--text"
  }, [_vm._v(" " + _vm._s(_vm.noDataText || _vm.$translate("noFormatFound")) + " ")])], 1) : _c('div', {
    staticClass: "format-select__step"
  }, [_c('div', {
    staticClass: "d-flex align-center px-2 pt-1"
  }, [_c('v-btn', {
    staticClass: "mr-1",
    attrs: {
      "icon": "",
      "x-small": ""
    },
    on: {
      "click": _vm.backToContainers
    }
  }, [_c('v-icon', {
    attrs: {
      "small": ""
    }
  }, [_vm._v("mdi-arrow-left")])], 1), _c('div', {
    staticClass: "text-body-2 font-weight-medium"
  }, [_vm._v(" " + _vm._s(_vm.selectedContainerLabel) + " ")])], 1), _vm.unitChoices.length > 1 ? _c('div', {
    staticClass: "px-3 pt-2"
  }, [_c('div', {
    staticClass: "text-caption grey--text text--darken-1 mb-1"
  }, [_vm._v(" " + _vm._s(_vm.$translate("pickUnit")) + " ")]), _c('v-chip-group', {
    attrs: {
      "value": _vm.selectedUnit,
      "mandatory": "",
      "column": ""
    },
    on: {
      "change": _vm.onUnitSelect
    }
  }, _vm._l(_vm.unitChoices, function (unit) {
    return _c('v-chip', {
      key: unit,
      attrs: {
        "value": unit,
        "filter": "",
        "small": "",
        "outlined": ""
      }
    }, [_vm._v(" " + _vm._s(unit) + " ")]);
  }), 1)], 1) : _vm._e(), _c('div', {
    staticClass: "format-select__step-title px-3 pt-2 pb-1 text-caption grey--text text--darken-1"
  }, [_vm._v(" " + _vm._s(_vm.$translate("pickQuantity")) + " "), _vm.selectedUnit && _vm.unitChoices.length === 1 ? _c('span', [_vm._v(" (" + _vm._s(_vm.selectedUnit) + ") ")]) : _vm._e()]), _vm.quantityChoices.length ? _c('v-list', {
    staticClass: "py-0 format-select__list",
    attrs: {
      "dense": ""
    }
  }, _vm._l(_vm.quantityChoices, function (quantity) {
    return _c('v-list-item', {
      key: String(quantity),
      "class": {
        'v-list-item--active': _vm.isQuantitySelected(quantity)
      },
      on: {
        "click": function click($event) {
          return _vm.onQuantitySelect(quantity);
        }
      }
    }, [_c('v-list-item-title', [_vm._v(" " + _vm._s(_vm.quantityChoiceLabel(quantity)) + " ")]), _vm.isQuantitySelected(quantity) ? _c('v-list-item-action', {
      staticClass: "my-0"
    }, [_c('v-icon', {
      attrs: {
        "small": "",
        "color": "primary"
      }
    }, [_vm._v("mdi-check")])], 1) : _vm._e()], 1);
  }), 1) : _c('div', {
    staticClass: "px-3 py-3 text-caption grey--text"
  }, [_vm._v(" " + _vm._s(_vm.$translate("noQuantityForUnit")) + " ")])], 1)]], 2)], 1)], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }